import "./index.scss";

export const TagPane = ({ children, tags, removeTag }) => {
  return (
    <div className="tagged-input uk-border-rounded uk-flex uk-flex-wrap uk-width-1-1 uk-position-z-index">
      <ul className="uk-iconnav uk-width-expand uk-margin-remove">
        {tags.map((tag, tagIndex) => (
          <li key={tagIndex} className="uk-label uk-padding-small uk-margin uk-margin-remove-vertical">
            {tag.name}
            <button
              className="uk-background-secondary uk-border-circle uk-margin-small-left"
              type="button"
              uk-close=""
              onClick={() => removeTag(tagIndex)}
            />
          </li>
        ))}
        <li className="input-container">{children}</li>
      </ul>
    </div>
  );
};
